module.exports = __webpack_public_path__ + "img/photo-0111.9dfff4f8.jpg";